export const MIMIC_MIN_SCALE = 1.0;
export const MIMIC_MAX_SCALE = 8.0;
export const MIMIC_DEFAULT_SCALE = 1.0;
export const MIMIC_SCALE_STEP = 0.2;
